import { Injectable } from '@angular/core';
import { LEADPOINT_MAPPING } from '../_static-settings/field-mapping.data';
import { LeadPointFormModel } from '../_models/lead-point-form-data.model';
import { FormDataModel } from '../_models/form-data.model';
import { FormDataMappingModel, FormDataSourceModel }  from '../_models/form-data-mapping.model';


@Injectable({
  providedIn: 'root'
})
export class FormDataMapperService {
  constructor() { }

  mapLeadToForm(sourceData: FormDataSourceModel): FormDataModel {    
    const result: Partial<FormDataModel> = {};
    const leadDetail = sourceData.leadDetail;

    LEADPOINT_MAPPING.forEach(mapping => {
      const targetField = mapping.fieldName as keyof FormDataModel;
      const sourceField = mapping.fieldMapping as keyof typeof leadDetail;
      if (sourceField && leadDetail[sourceField] !== undefined) {

        const sourceValue = leadDetail[sourceField];
                
        result[targetField] = this.convertValue(
          targetField, 
          sourceValue.toString()
        ) as any;
      } else {        
        result[targetField] = this.getDefaultValue(targetField);
      }
    });

    return result as FormDataModel;
  }


  private convertValue(fieldName: keyof FormDataModel, value: string): any {
    const numericFields = [
      'EstimatedHomeValue', 
      'LoanAmount', 
      'InterestRateLoan1',
      'LoanTerm',
      'CashOut'
    ];
    
    const booleanFields = ['VAStatus'];
    
    if (numericFields.includes(fieldName)) {
      const num = parseFloat(value);
      return isNaN(num) ? 0 : num;
    }
    
    if (booleanFields.includes(fieldName)) {
      const upperValue = value.toUpperCase();
      return upperValue === 'YES' || upperValue === 'TRUE' || upperValue === '1';
    }
    return value;
  }


  private getDefaultValue(fieldName: keyof FormDataModel): any {
    const defaults: Partial<FormDataModel> = {
      terms_accepted: '',
      LoanTerm: 30,
      CurrentLoanType: '',
      PropertyType: '',
      RoofingType: '',
      RoofingMaterial: '',
      RoofingSteep: '',
      RoofingStories: '',
      HomeOwner: '',
      VAStatus: false,
      CashOut: 0,
      EstimatedHomeValue: 0,
      LoanAmount: 0,
      InterestRateLoan1: 0
    };

    return defaults[fieldName] !== undefined 
      ? defaults[fieldName] 
      : '';
  }

  mapFormToLead(formData: FormDataModel): FormDataSourceModel {
    const leadDetail: any = {};

    LEADPOINT_MAPPING.forEach(mapping => {
      const sourceField = mapping.fieldMapping;
      const targetField = mapping.fieldName as keyof FormDataModel;
      
      if (sourceField && formData[targetField] !== undefined) {
        leadDetail[sourceField] = formData[targetField];
      }
    });

    return { leadDetail };
  }

}
